import React from 'react';

import { OverlaySpinner } from 'components/Spinner';
import { RouteFC } from 'util/routeTypes';

import { useAppStoreRedirectEffect } from 'hooks/useAppStoreRedirectEffect/useAppStoreRedirectEffect';
import { useSmartNavigate } from 'hooks/useSmartNavigate';

export const AppDownloadPage: RouteFC<{children?: never}> = () => {
  const navigate = useSmartNavigate();

  useAppStoreRedirectEffect(() => navigate('~/not-found'), []);

  return <OverlaySpinner />;
};
